(function () {
  'use strict';

  // Keep in sync with LANGUAGES in src/static/uploads/code-block-language.js (editor dropdown)
  var LANG_NAMES = {
    'powershell': 'PowerShell',
    'bash': 'Bash',
    'batch': 'Batch',
    'python': 'Python',
    'json': 'JSON',
    'xml': 'XML',
    'markup': 'HTML',
    'html': 'HTML',
    'ini': 'INI',
    'csharp': 'C#',
    'cs': 'C#'
  };

  function getLangFromCode(codeEl) {
    var cls = codeEl.className || '';
    var match = cls.match(/language-([\w-]+)/);
    return match ? match[1] : null;
  }

  function setButtonState(button, iconClass, label, copied) {
    button.textContent = '';
    var icon = document.createElement('i');
    icon.className = iconClass;
    button.appendChild(icon);
    button.appendChild(document.createTextNode(' ' + label));
    button.classList.toggle('code-block-copy--copied', copied);
  }

  function copyToClipboard(text, button) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () {
        showCopied(button);
      }, function () {
        fallbackCopy(text, button);
      });
    } else {
      fallbackCopy(text, button);
    }
  }

  function fallbackCopy(text, button) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    showCopied(button);
  }

  function showCopied(button) {
    setButtonState(button, 'icon-check', 'Copied!', true);
    setTimeout(function () {
      setButtonState(button, 'icon-copy', 'Copy', false);
    }, 2000);
  }

  function enhanceCodeBlock(pre) {
    var code = pre.querySelector('code');
    var textSource = code || pre;

    pre.classList.add('code-block-enhanced');

    var wrapper = document.createElement('div');
    wrapper.className = 'code-block-wrapper';

    var header = document.createElement('div');
    header.className = 'code-block-header';

    var lang = code ? getLangFromCode(code) : null;
    var langLabel = document.createElement('span');
    langLabel.className = 'code-block-lang';
    if (lang) {
      langLabel.textContent = LANG_NAMES[lang] || lang;
    }
    header.appendChild(langLabel);

    var copyBtn = document.createElement('button');
    copyBtn.type = 'button';
    copyBtn.className = 'code-block-copy';
    setButtonState(copyBtn, 'icon-copy', 'Copy', false);
    copyBtn.addEventListener('click', function () {
      copyToClipboard(textSource.textContent, copyBtn);
    });
    header.appendChild(copyBtn);

    pre.parentNode.insertBefore(wrapper, pre);
    wrapper.appendChild(header);
    wrapper.appendChild(pre);

    if (lang && code && typeof Prism !== 'undefined') {
      Prism.highlightElement(code);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var containers = document.querySelectorAll('.prose-content');
    containers.forEach(function (container) {
      var pres = container.querySelectorAll('pre');
      pres.forEach(enhanceCodeBlock);
    });
  });
})();
